<template>
    <div class="content">
        <h3 ref="pageHeader" class="pageHeader">安全课程成绩统计</h3>
        <!-- 查询区 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
            <el-form-item label="课程名称">
                <el-input v-model="formInline.title" clearable placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="院系">
                <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell"
                    @handleOrganQuery="handleOrganQuery1">
                </OrganDialog>
                <el-input v-model="formInline.depart" placeholder="请选择院系" @focus="dialogOpen1" @clear="handeleClear1"
                    clearable></el-input>
            </el-form-item>
            <el-form-item label="创建人">
                <el-input v-model="formInline.create_name" clearable placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="创建时间">
                <el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:300px;" clearable>
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleQuery">查询</el-button>
            </el-form-item>
        </el-form>
        <!-- 列表 -->
        <custom-table :data="tableData" border style="width: 100%">
            <custom-table-column fixed label="序号" type="index" width="50">
            </custom-table-column>
            <custom-table-column prop="title" fixed label="课程名称" min-width="160" show-overflow-tooltip>
            </custom-table-column>
            <custom-table-column prop="depart" label="所属院系" width="140">
            </custom-table-column>
            <custom-table-column label="学习人数" width="100">
                <template slot-scope="scope">
                    <span>{{ learnNum(scope.row) }}</span>
                </template>
            </custom-table-column>
            <custom-table-column prop="create_name" label="创建人" width="110">
            </custom-table-column>
            <custom-table-column prop="created_at" label="创建时间" width="170">
            </custom-table-column>
            <custom-table-column label="课程描述" min-width="200" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{ scope.row.desc || scope.row.description || '-' }}</span>
                </template>
            </custom-table-column>
            <custom-table-column fixed="right" label="操作" width="230">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="handleCourseDetail(scope.row)">课程详情</el-button>
                    <el-button type="text" size="small" @click="handleAnswerDetail(scope.row)">答题详情</el-button>
                    <el-button type="text" size="small" @click="handleStudyProgress(scope.row)">学习进度</el-button>
                </template>
            </custom-table-column>
        </custom-table>
        <div class="pageLine">
            <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
        </div>
        <!-- 课程详情弹窗(复用公共课程表单,只读) -->
        <el-dialog :close-on-click-modal="false" title="课程详情" :visible.sync="scoreDetailVisible" width="760px">
            <course-form ref="scoreCourseForm" :value="scoreForm" type="view"
                :exam-config-row="scoreDetailRow"></course-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="scoreDetailVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 答题详情弹窗(统计卡片 + 答题明细) -->
        <el-dialog :close-on-click-modal="false"
            :title="'答题详情' + (answerCourseName ? ' - ' + answerCourseName : '')" :visible.sync="answerDetailVisible"
            width="1150px">
            <div class="statCards">
                <div class="statCard">
                    <div class="statNum">{{ statNum(['total']) }}</div>
                    <div class="statLabel">应学习人数</div>
                </div>
                <div class="statCard">
                    <div class="statNum">{{ statNum(['learned']) }}</div>
                    <div class="statLabel">已参考</div>
                </div>
                <div class="statCard">
                    <div class="statNum">{{ statNum(['exam_status']) }}</div>
                    <div class="statLabel">考试通过</div>
                </div>
                <div class="statCard">
                    <div class="statNum">{{ statNum(['is_certificate']) }}</div>
                    <div class="statLabel">有效证书</div>
                </div>
            </div>
            <el-form :inline="true" :model="answerQuery" class="demo-form-inline" label-position="left"
                style="margin-top:14px;">
                <el-form-item label="关键字">
                    <el-input v-model="answerQuery.keyword" clearable placeholder="姓名/学号/工号"
                        style="width:180px;"></el-input>
                </el-form-item>
                <el-form-item label="人员类型">
                    <el-select v-model="answerQuery.user_type" clearable placeholder="全部" style="width:160px;">
                        <el-option v-for="item in $store.state.userTypeOptions" :key="item" :label="item"
                            :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="考试结果">
                    <el-select v-model="answerQuery.exam_status" clearable placeholder="全部" style="width:140px;">
                        <el-option v-for="item in $store.state.exam_status" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="证书状态">
                    <el-select v-model="answerQuery.certificate_status" clearable placeholder="全部" style="width:140px;">
                        <el-option v-for="item in $store.state.certificate_status" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleAnswerQuery">查询</el-button>
                </el-form-item>
            </el-form>
            <custom-table :data="answerTableData" border style="width: 100%">
                <custom-table-column fixed label="序号" type="index" width="50">
                </custom-table-column>
                <custom-table-column prop="user_name" label="姓名" min-width="140">
                </custom-table-column>
                <custom-table-column prop="user_type" label="人员类型" width="170" show-overflow-tooltip>
                </custom-table-column>
                <custom-table-column prop="major" label="专业" min-width="120">
                </custom-table-column>
                <custom-table-column prop="exam_count" label="考试次数" width="100">
                </custom-table-column>
                <custom-table-column prop="max_score" label="最高分" width="100">
                </custom-table-column>
                <custom-table-column label="考试结果" width="110">
                    <template slot-scope="scope">
                        <span>{{ dictLabel('exam_status', scope.row.exam_status) }}</span>
                    </template>
                </custom-table-column>
                <custom-table-column label="证书状态" width="110">
                    <template slot-scope="scope">
                        <span>{{ dictLabel('certificate_status', scope.row.certificate_status) }}</span>
                    </template>
                </custom-table-column>
                <custom-table-column fixed="right" label="操作" width="110">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleAnswerPreview(scope.row)">查看详情</el-button>
                    </template>
                </custom-table-column>
            </custom-table>
        </el-dialog>
        <!-- 考试卷列表(同一考生有多份答卷时先列出来,再从列表进详情) -->
        <el-dialog :close-on-click-modal="false"
            :title="'考试卷列表' + (previewUserName ? ' - ' + previewUserName : '')"
            :visible.sync="answerPaperListVisible" width="700px">
            <custom-table :data="answerPaperList" border style="width: 100%">
                <custom-table-column fixed label="序号" type="index" width="60"></custom-table-column>
                <custom-table-column prop="score" label="得分" width="100"></custom-table-column>
                <custom-table-column prop="ctime" label="提交时间" min-width="180"></custom-table-column>
                <custom-table-column fixed="right" label="操作" width="110">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handlePreviewRecord(scope.row)">试卷详情</el-button>
                    </template>
                </custom-table-column>
            </custom-table>
        </el-dialog>
        <!-- 试卷预览弹窗(与答题详情弹窗同级,避免弹窗套弹窗) -->
        <el-dialog :close-on-click-modal="false"
            :title="'试卷预览' + (previewUserName ? ' - ' + previewUserName : '')" :visible.sync="previewVisible"
            width="720px" destroy-on-close>
            <ExamPage :key="previewKey" v-if="previewVisible" :formData="previewFormData" show-result
                :total-score="previewTotalScore"></ExamPage>
        </el-dialog>
        <!-- 学习进度弹窗(统计卡片 + 进度明细) -->
        <el-dialog :close-on-click-modal="false"
            :title="'学习进度' + (progressCourseName ? ' - ' + progressCourseName : '')"
            :visible.sync="progressDetailVisible" width="1150px">
            <div class="statCards">
                <div class="statCard">
                    <div class="statNum">{{ statVal(['total']) }}</div>
                    <div class="statLabel">应学习人数</div>
                </div>
                <div class="statCard">
                    <div class="statNum">{{ statVal(['learned']) }}</div>
                    <div class="statLabel">已完成</div>
                </div>
                <div class="statCard">
                    <div class="statNum">{{ statVal(['learning']) }}</div>
                    <div class="statLabel">学习中</div>
                </div>
                <div class="statCard">
                    <div class="statNum">{{ statVal(['no_learn']) }}</div>
                    <div class="statLabel">未开始</div>
                </div>
            </div>
            <el-form :inline="true" :model="progressQuery" class="demo-form-inline" label-position="left"
                style="margin-top:14px;">
                <el-form-item label="关键字">
                    <el-input v-model="progressQuery.keyword" clearable placeholder="姓名/学号/工号"
                        style="width:180px;"></el-input>
                </el-form-item>
                <el-form-item label="人员类型">
                    <el-select v-model="progressQuery.user_type" clearable placeholder="全部" style="width:160px;">
                        <el-option v-for="item in $store.state.userTypeOptions" :key="item" :label="item"
                            :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="考试结果">
                    <el-select v-model="progressQuery.exam_status" clearable placeholder="全部" style="width:140px;">
                        <el-option v-for="item in $store.state.exam_status" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="证书状态">
                    <el-select v-model="progressQuery.certificate_status" clearable placeholder="全部"
                        style="width:140px;">
                        <el-option v-for="item in $store.state.certificate_status" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleProgressQuery">查询</el-button>
                </el-form-item>
            </el-form>
            <custom-table :data="progressTableData" border style="width: 100%">
                <custom-table-column fixed label="序号" type="index" width="50">
                </custom-table-column>
                <custom-table-column prop="user_name" label="姓名" min-width="140">
                </custom-table-column>
                <custom-table-column prop="user_type" label="人员类型" width="170" show-overflow-tooltip>
                </custom-table-column>
                <custom-table-column prop="progress_str" label="学习资料进度" width="110">
                </custom-table-column>
                <custom-table-column prop="progress" label="学习进度" width="120">
                </custom-table-column>
                <custom-table-column label="证书状态" width="110">
                    <template slot-scope="scope">
                        <span>{{ dictLabel('certificate_status', scope.row.certificate_status) }}</span>
                    </template>
                </custom-table-column>
                <custom-table-column prop="last_time" label="最近学习时间" min-width="180">
                </custom-table-column>
            </custom-table>
        </el-dialog>
    </div>
</template>

<script>
import PageLine from '@/components/page.vue';
import CourseForm from './components/courseForm.vue';
import ExamPage from '@/components/examPage.vue';
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';

export default {
    name: 'safeCourseScore',
    mixins: [mixinList, mixinOrgan],
    components: {
        PageLine,
        CourseForm,
        ExamPage,
    },
    data() {
        return {
            // 查询条件(与接口参数同名:title/depart/create_name)
            formInline: {
                title: '',
                depart: '',
                create_name: ''
            },
            levell: [1],
            // 日期范围,提交时拆成 start_date/end_date
            dateRange: [],
            // 课程详情弹窗(只读 view,value 键结构对齐公共课程表单组件)
            scoreDetailVisible: false,
            // 当前查看行(供考试配置等附加只读展示,数据取自列表行)
            scoreDetailRow: {},
            scoreForm: {
                id: '',
                title: '',
                desc: '',
                start_date: '',
                end_date: '',
                safe_level: '',
                expire_month: '',
                pre_exam: '',
                user_type: '',
                end_doing: '',
                training_room_id: '',
                structure_1: '',
                structure_2: '',
                resources_ids: [],
                teacher_ids: [],
                student_ids: []
            },
            // 答题详情弹窗(统计卡片 + 明细)
            answerDetailVisible: false,
            answerCourseId: '',
            answerCourseName: '',
            answerQuestionName: '',
            answerQuestionId: '',
            // 考试卷列表弹窗(同一考生有多份答卷时先列出来)
            answerPaperListVisible: false,
            answerPaperList: [],
            // 试卷预览弹窗(答题明细里的"查看详情")
            previewVisible: false,
            previewKey: 0,
            previewUserName: '',
            previewTotalScore: '',
            previewFormData: {},
            // 查询条件(course_id 必带;exam/certificate 默认 0 与接口示例一致,可清空为全部)
            answerQuery: {
                course_id: '',
                keyword: '',
                user_type: '',
                exam_status: '',
                certificate_status: ''
            },
            // 统计卡片:total 应学习 / learned 已参考 / exam_status 考试通过 / is_certificate 有效证书
            answerStat: {},
            answerTableData: [],
            // 学习进度弹窗(统计卡片 + 进度明细)
            progressDetailVisible: false,
            progressCourseId: '',
            progressCourseName: '',
            // 查询条件同答题详情(course_id 必带)
            progressQuery: {
                course_id: '',
                keyword: '',
                user_type: '',
                exam_status: '',
                certificate_status: ''
            },
            // 统计卡片:total 应学习 / learned 已完成 / learning 学习中 / no_learn 未开始
            progressStat: {},
            progressTableData: []
        };
    },
    methods: {
        handleQuery() {
            if (this.selectNodeForQuery.level == 1) {
                this.formInline.depart = this.selectNodeForQuery.structure_names;
            } else {
                this.formInline.depart = '';
            }
            this.$refs.pageChild.page = 1;
            this.getList();
        },
        async getList() {
            let params = this.$until.deleteNullPrototype(this.formInline);
            if (this.dateRange && this.dateRange.length === 2) {
                params.start_date = this.dateRange[0];
                params.end_date = this.dateRange[1];
            }
            params.page = this.$refs.pageChild.page;
            params.size = this.$refs.pageChild.size;
            let res = await this.$api.instance.interfaceServer('api/new_course/score/list', 'get', params);
            if (res.code == 0 && res.data) {
                this.tableData = res.data.data;
                this.total = res.data.total;
            }
        },
        // 学习人数:接口返回字段名待联调,多候选兜底展示
        learnNum(row) {
            const keys = ['learn_count', 'study_num', 'study_count', 'people_count', 'user_count', 'student_count', 'num'];
            for (let i = 0; i < keys.length; i++) {
                if (row[keys[i]] !== undefined && row[keys[i]] !== null) return row[keys[i]];
            }
            return '-';
        },
        // 课程详情:直接从列表数据取(列表已含 desc 等字段),公共课程表单组件只读展示
        handleCourseDetail(row) {
            this.scoreDetailVisible = true;
            this.scoreDetailRow = row || {};
            this.$nextTick(() => {
                if (this.$refs.scoreCourseForm) {
                    this.$refs.scoreCourseForm.openView(row);
                }
            });
        },
        // 答题详情:弹窗内统计卡片 + 答题明细(course_id 取自当前课程行)
        handleAnswerDetail(row) {
            this.answerCourseId = row.id || row.course_id || '';
            this.answerCourseName = row.title || '';
            this.answerQuestionName = row.question_name || '';
            this.answerQuestionId = row.question_id || '';
            this.answerQuery.course_id = this.answerCourseId;
            this.answerTableData = [];
            this.answerStat = {};
            this.answerDetailVisible = true;
            this.$nextTick(() => {
                this.handleAnswerQuery();
            });
        },
        handleAnswerQuery() {
            this.getAnswerStat();
            this.getAnswerList();
        },
        // 答题明细的"查看详情":取该考生的提交记录
        // 接口:api/questionnaire/quesubmit/detail?course_id=&user_id=(response 是该考生作答的题目 JSON 串)
        // 只有一份答卷直接预览;多份先列考试卷列表,再从列表进详情
        async handleAnswerPreview(row) {
            let res = await this.$api.instance.interfaceServer('api/questionnaire/quesubmit/detail', 'get', {
                course_id: this.answerCourseId,
                user_id: row.user_id
            });
            if (res.code != 0) return;
            let records = Array.isArray(res.data) ? res.data : [];
            if (!records.length) {
                this.$message({ type: 'warning', center: true, message: '该考生没有可预览的答题内容' });
                return;
            }
            this.previewUserName = row.user_name || '';
            if (records.length > 1) {
                this.answerPaperList = records;
                this.answerPaperListVisible = true;
                return;
            }
            this.handlePreviewRecord(records[0]);
        },
        // 预览某一份答卷
        async handlePreviewRecord(record) {
            let parsed = this.parseAnswerRecord([record]);

            if (!parsed.questions.length) {
                this.$message({ type: 'warning', center: true, message: '该次考试没有可预览的答题内容' });
                return;
            }
            // 试卷名与及格线取自课程绑定的试卷(question_id)
            // let paper = {};
            // if (this.answerQuestionId) {
            //     let paperRes = await this.$api.instance.interfaceServer(`api/new/paper/detail/${this.answerQuestionId}/${this.answerCourseId}`, 'get');
            //     if (paperRes.code == 0 && paperRes.data) paper = paperRes.data;
            // }
            this.previewTotalScore = parsed.score;
            this.previewFormData = {
                name:  this.answerQuestionName || this.answerCourseName || '',
                pass_line: parsed.new_paper? parsed.new_paper.pass_line : parsed.pass_line || '',
                questions: parsed.questions
            };
            this.previewKey++; // 强制重建 ExamPage,保证它挂载时 formData 已就绪
            this.previewVisible = true;
        },
        // response 是该考生作答的题目数组(JSON 字符串),从后往前取第一条能解析的
        // 返回 { questions, score }:questions 供试卷预览,score 为该次提交的总分
        parseAnswerRecord(records) {
            for (let i = records.length - 1; i >= 0; i--) {
                let raw = records[i].response;
                if (!raw) continue;
                try {
                    let list = JSON.parse(raw);
                    if (!Array.isArray(list) || !list.length) continue;
                    return {
                        score: records[i].score,
                        new_paper: records[i].new_paper || null,
                        // 题型有"单选题/多选题"和"单选/多选"两种写法,统一成 examPage 认的值
                        questions: list.map(item => Object.assign({}, item, {
                            type: item.type && item.type.indexOf('多选') > -1 ? '多选' : '单选'
                        }))
                    };
                } catch (e) {
                    // 脏数据(不是 JSON)继续往前找
                }
            }
            return { questions: [], score: '' };
        },
        // 统计:api/questionnaire/quesubmit/statistics(total 应学习/learned 已参考/exam_status 考试通过/is_certificate 有效证书)
        async getAnswerStat() {
            let params = this.$until.deleteNullPrototype(Object.assign({}, this.answerQuery));
            let res = await this.$api.instance.interfaceServer('api/questionnaire/quesubmit/statistics', 'get', params);
            if (res.code == 0 && res.data) {
                this.answerStat = (res.data.data && typeof res.data.data == 'object') ? res.data.data : res.data;
            }
        },
        // 明细列表:api/questionnaire/quesubmit/list(不分页,返回 data 为数组,直接全量展示)
        async getAnswerList() {
            let params = this.$until.deleteNullPrototype(Object.assign({}, this.answerQuery));
            let res = await this.$api.instance.interfaceServer('api/questionnaire/quesubmit/list', 'get', params);
            if (res.code == 0 && res.data) {
                this.answerTableData = Array.isArray(res.data) ? res.data : [];
            }
        },
        // 统计卡片取值:字段名多候选(待联调确认后可直接替换)
        statNum(keys) {
            const st = this.answerStat || {};
            for (let i = 0; i < keys.length; i++) {
                if (st[keys[i]] !== undefined && st[keys[i]] !== null) return st[keys[i]];
            }
            return 0;
        },
        // 字典 value → label(exam_status / certificate_status 等)
        dictLabel(dictKey, val) {
            if (val === undefined || val === null || val === '') return '-';
            const arr = this.$store.state[dictKey] || [];
            const hit = arr.find(it => String(it.value) === String(val));
            return hit ? hit.label : val;
        },
        // 学习进度:弹窗内统计卡片 + 进度明细(course_id 取自当前课程行)
        handleStudyProgress(row) {
            this.progressCourseId = row.id || row.course_id || '';
            this.progressCourseName = row.title || '';
            this.progressQuery.course_id = this.progressCourseId;
            this.progressTableData = [];
            this.progressStat = {};
            this.progressDetailVisible = true;
            this.$nextTick(() => {
                this.handleProgressQuery();
            });
        },
        handleProgressQuery() {
            this.getProgressStat();
            this.getProgressList();
        },
        // 统计:api/questionnaire/resources/statistics(total 应学习/learned 已完成/learning 学习中/no_learn 未开始)
        async getProgressStat() {
            let params = this.$until.deleteNullPrototype(Object.assign({}, this.progressQuery));
            let res = await this.$api.instance.interfaceServer('api/questionnaire/resources/statistics', 'get', params);
            if (res.code == 0 && res.data) {
                this.progressStat = (res.data.data && typeof res.data.data == 'object') ? res.data.data : res.data;
            }
        },
        // 明细列表:api/questionnaire/resources/list(不分页,返回 data 为数组则直接展示)
        async getProgressList() {
            let params = this.$until.deleteNullPrototype(Object.assign({}, this.progressQuery));
            let res = await this.$api.instance.interfaceServer('api/questionnaire/resources/list', 'get', params);
            if (res.code == 0 && res.data) {
                this.progressTableData = Array.isArray(res.data)
                    ? res.data : (Array.isArray(res.data.data) ? res.data.data : []);
            }
        },
        // 学习进度统计卡片取值(total/learned/learning/no_learn)
        statVal(keys) {
            const st = this.progressStat || {};
            for (let i = 0; i < keys.length; i++) {
                if (st[keys[i]] !== undefined && st[keys[i]] !== null) return st[keys[i]];
            }
            return 0;
        },
    },
};
</script>

<style lang="less" scoped>
.pageHeader:before {
    width: var(--width);
}

.statCards {
    display: flex;
    gap: 16px;
}

.statCard {
    flex: 1;
    border: 1px solid #e8ecf1;
    border-radius: 6px;
    padding: 14px 10px;
    text-align: center;
    background: #fafbfd;

    .statNum {
        font-size: 28px;
        font-weight: bold;
        color: var(--blue);
        line-height: 1.3;
    }

    .statLabel {
        margin-top: 4px;
        color: #666;
        font-size: 13px;
    }
}
</style>
